export default function getSelectData(response) {
  const data = response.data.response.map((item) => {
    return { value: item.id, label: item.name };
  });
  return { ...response, list: data };
}
